import "./App.css";
import Notes from "./components/Notes/Notes";

function App() {
  return (
    <div className="App">
      <Notes></Notes>
    </div>
  );
}

export default App;
